import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("game_admin_token")}` },
});
